// Mobile bottom navigation bar for desktop responsive site
// Shows at phone widths (<=576px) with 5 tabs matching Figma design.
// Signed-out users can browse Explore; other tabs navigate to signup.
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { pageURLs } from "@/constants/pageURLs";
import { loggedInUser } from "@/helpers/common";
import { isBLSDomain } from "../BLSMobileGate/BLSMobileGate";

const MobileBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = loggedInUser();
  const currentPath = location.pathname;
  const isBLS = isBLSDomain();

  const handleNav = (path, requiresAuth = true) => {
    if (requiresAuth && !user) {
      navigate(pageURLs.home);
      return;
    }
    navigate(path);
  };

  const isActive = (path) => currentPath === path;

  const fourthTabPath = isBLS
    ? pageURLs.agentInventoryListing
    : pageURLs.consumerInventoryListing;
  const fourthTabLabel = isBLS ? "Inventory" : "Dashboard";

  const fifthTabPath = isBLS ? pageURLs.agentMyClients : pageURLs.messages;
  const fifthTabLabel = isBLS ? "Clients" : "Notifications";

  return (
    <nav className="mobile-bottom-nav">
      {/* Explore */}
      <button
        className={`mobile-bottom-nav__item ${isActive(pageURLs.home) ? "active" : ""}`}
        onClick={() => handleNav(pageURLs.home, false)}
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="11" cy="11" r="8"/>
          <line x1="21" y1="21" x2="16.65" y2="16.65"/>
        </svg>
        <span>Explore</span>
      </button>

      {/* Match */}
      <button
        className={`mobile-bottom-nav__item ${isActive(pageURLs.agentMyWantAdListings) ? "active" : ""}`}
        onClick={() => handleNav(pageURLs.agentMyWantAdListings)}
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="8" height="8" rx="1.5"/>
          <rect x="13" y="3" width="8" height="8" rx="1.5"/>
          <rect x="3" y="13" width="8" height="8" rx="1.5"/>
          <rect x="13" y="13" width="8" height="8" rx="1.5"/>
        </svg>
        <span>Match</span>
      </button>

      {/* Add */}
      <button
        className={`mobile-bottom-nav__item ${isActive(pageURLs.agentCreatewantadMainScreen) ? "active" : ""}`}
        onClick={() => handleNav(pageURLs.agentCreatewantadMainScreen)}
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="4"/>
          <line x1="12" y1="8" x2="12" y2="16"/>
          <line x1="8" y1="12" x2="16" y2="12"/>
        </svg>
        <span>Add</span>
      </button>

      {/* Dashboard / Inventory */}
      <button
        className={`mobile-bottom-nav__item ${isActive(fourthTabPath) ? "active" : ""}`}
        onClick={() => handleNav(fourthTabPath)}
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="4" width="18" height="16" rx="2"/>
          <line x1="3" y1="10" x2="21" y2="10"/>
          <line x1="9" y1="4" x2="9" y2="10"/>
        </svg>
        <span>{fourthTabLabel}</span>
      </button>

      {/* Notifications / Clients */}
      <button
        className={`mobile-bottom-nav__item ${isActive(fifthTabPath) ? "active" : ""}`}
        onClick={() => handleNav(fifthTabPath)}
      >
        {isBLS ? (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
            <circle cx="9" cy="7" r="4"/>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
          </svg>
        ) : (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
            <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
          </svg>
        )}
        <span>{fifthTabLabel}</span>
      </button>
    </nav>
  );
};

export default MobileBottomNav;
